interface Currency {
  value: string
  logo: string
}

interface Currencies {
  [key: string]: Currency
}

export const currencies: Currencies = {
  SAR: {
    value: 'SAR',
    logo: 'SR',
  },
  USD: {
    value: 'USD',
    logo: '$',
  },
}
